import { FC, memo } from 'react';
import { Button, Flex } from 'antd';
import { createColumnHelper } from '@tanstack/react-table';
import {
  CategoryHierarchyValidFormDataType,
  ExpandTableRowButton,
  ROW_UNIQUE_KEY_NAME,
  Table,
  TextEllipsis,
  TreeNode,
} from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './CategoryHierarchyFormTable.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('category-hierarchy');
addTranslations(translations);

const columnHelper = createColumnHelper<CategoryHierarchyValidFormDataType>();

export const CategoryHierarchyViewTable: FC<{
  hirarchy: TreeNode<{ childSequenceNumber: number; displayName: string }>[];
}> = (props) => {
  const { hirarchy } = props;
  const { t } = useTranslation();

  return (
    <Flex vertical gap="middle" align="end" style={{ width: 'fit-content' }}>
      <Table
        data={hirarchy}
        name="hierarchy"
        rowKey={ROW_UNIQUE_KEY_NAME}
        actions={(table) => (
          <>
            <Button
              id="expand-all"
              onClick={() => table.toggleAllRowsExpanded(true)}
            >
              {t('button.expand-all')}
            </Button>
            <Button
              id="collapse-all"
              onClick={() => table.toggleAllRowsExpanded(false)}
            >
              {t('button.collapse-all')}
            </Button>
          </>
        )}
        columns={[
          columnHelper.accessor('displayName', {
            header: t('column.displayName'),
            cell: (props) => (
              <ExpandTableRowButton {...props}>
                <TextEllipsis>{props.renderValue()}</TextEllipsis>
                {props.row.subRows.length > 0 &&
                  `(${props.row.subRows.length})`}
              </ExpandTableRowButton>
            ),
            enableSorting: false,
            meta: {
              width: 350,
            },
          }),
          columnHelper.accessor('childSequenceNumber', {
            header: t('column.childSequenceNumber'),
            cell: memo((props) => props.renderValue()),
            enableSorting: false,
            enableColumnFilter: false,
            meta: {
              width: 100,
              textAlign: 'right',
            },
          }),
          columnHelper.accessor('parent' as any, {
            header: t('column.parent'),
            cell: memo((props) => {
              const parentName = props.row.getParentRow()?.original.displayName;
              return parentName ? (
                <TextEllipsis>{parentName}</TextEllipsis>
              ) : null;
            }),
            enableSorting: false,
            enableColumnFilter: false,
            meta: {
              minWidth: 200,
            },
          }),
        ]}
        sticky
        virtual
        scrollContainerSelector="#detail-layout-main-content"
      />
    </Flex>
  );
};
